<script>
export default {
  props: {
    css: {
      type: Object,
      default() {
        return {
          infoClass: 'left floated left aligned six wide column'
        }
      }
    },
    infoTemplate: {
      type: String,
      default() {
        return "Mostrando {from} a {to} de {total} items [{selectedTotal} itens selecionados]"
      }
    },
    noDataTemplate: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data: function() {
    return {
      tablePagination: null
    }
  },
  computed: {
    paginationInfo () {
      if (this.tablePagination == null || this.tablePagination.total == 0) {
        return this.noDataTemplate
      }


      const table = this.$parent.$refs.vuetable
      const selectedRowsLength = table.selectedRows ? table.selectedRows.length : 0

      let infoMessage = this.infoTemplate 
        .replace('{from}', this.tablePagination.from || 0)
        .replace('{to}', this.tablePagination.to || 0)
        .replace('{total}', this.tablePagination.total || 0)
        .replace('{selectedTotal}', this.$parent.$refs.vuetable.selectedTo.length || 0)

      if (selectedRowsLength > 0) {
        selectedRowsLength == 1 ? 
        infoMessage += ' (' + selectedRowsLength + ' item selecionado)' :
        infoMessage += ' (' + selectedRowsLength + ' itens selecionados)'
      }

      return infoMessage;
    }
  },
  methods: {
    setPaginationData (tablePagination) {
      this.tablePagination = tablePagination
    },
    resetData () {
      this.tablePagination = null
    }
  },
}
</script>
